import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SitesBuilderGuard  {
  constructor( 
              private authService: AuthService, 
              private router: Router, 
              private toastr: ToastrService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.authService.checkAdminUser().subscribe({
        next: response => {
          console.log('isAdmin? ', response);
          const permission = response.result;
          if (permission === true) {
            return true;
          } else {
            this.router.navigate(['/dashboard']);
            this.toastr.error('', 'Permission denied');
            return false;
          }
        },
        error: error => {
          console.error(error);
          return false;
        }
      });

    return true;
  }
  
}
